import React from "react";
import styled from "styled-components";

type FeedbackModalProps = {
  type: "success" | "error";
  message: string;
  open?: boolean;
  onClose?: () => void;
};

const FeedbackModal: React.FC<FeedbackModalProps> = ({
  type,
  message,
  open,
  onClose,
}) => {
 
  return (
    <Container
      title={type === "success" ? "Sucesso!" : "Erro!"}
      style={{
        // Precisa ficar acima do header/sidebar (z-index 30/40 no design
        // system) e de qualquer Drawer aberto (z-index 91) — o ModalPriorityEnum
        // usado antes aqui é uma escala relativa pequena (1-6) pra ordenar
        // modais entre si, não serve como z-index absoluto de CSS.
        zIndex: 9999,
        borderRadius: "8px",
        position: "fixed",
        // Header tem 64px de altura (--topbar-h) — 84px deixa uma folga de
        // 20px abaixo dele, então não cobre mais o avatar/ícones de ação.
        top: 84,
        right: 30,
        backgroundColor: type === "success" ? "#a1f5a4" : "#f5adad",
        borderBottom:
          type === "success" ? "7px solid #0c8510" : "7px solid #9b1818",
        color: type === "success" ? "#005f04" : "#640000",
      }}
    >
      <p>{message}</p>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
`;

export default FeedbackModal;
